import { TextStyle } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';

const RandomText = ({ text, weight, variation, maintainText }) => {
  const textArray = Array.isArray(text) ? text : [text];

  const length = textArray.length;
  const randomIndex = Math.floor(Math.random() * length);
  const textData = textArray?.[randomIndex] || text;

  const [displayText, setDisplayText] = useState(null);
  const displayTextRef = React.useRef(null);
  displayTextRef.current = displayText;

  useEffect(() => {
    if (maintainText) {
      if (!displayTextRef.current) {
        setDisplayText(textData);
      }
    } else {
      setDisplayText(textData);
    }
  }, [textData, maintainText]);

  return (
    <TextStyle weight={weight} variation={variation}>
      {displayText}
    </TextStyle>
  );
};

export default RandomText;
